<template>
  <ul class="nav-list">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'nav-list',

  inject: {
    handleNav: {}
  }
}
</script>
